import { render, staticRenderFns } from "./groupGoods.vue?vue&type=template&id=191ffe8c"
import script from "./groupGoods.vue?vue&type=script&lang=js"
export * from "./groupGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports